import { Check } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { SignatureSymbol } from "@/components/SignatureSymbol";
import { SESSIONS, CONTACT, waLink } from "@/data";

export default function Sessions() {
  return (
    <section id="sessions" data-testid="sessions-section" className="section-pad py-24 md:py-36 relative overflow-hidden">
      <SignatureSymbol className="absolute -right-10 top-10 w-[320px] h-[340px] opacity-[0.05] pointer-events-none" color="var(--gold)" />

      <div className="max-w-2xl mb-14 relative z-10">
        <Overline>Sessions &amp; Offerings</Overline>
        <Reveal>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-6">
            Choose the guidance that calls to you.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-sans-ui text-[var(--muted-ink)] text-base md:text-lg leading-relaxed font-light mt-6">
            Two thoughtfully crafted offerings, conducted online so you can connect from anywhere in the world. Available 9 AM &ndash; 5 PM IST &mdash; reach out on WhatsApp to reserve your time.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 gap-8 relative z-10">
        {SESSIONS.map((s, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div
              data-testid={`session-card-${i}`}
              className={`h-full flex flex-col p-8 md:p-10 border transition-all duration-500 ${
                s.featured
                  ? "noir grain border-[rgba(233,172,70,0.4)]"
                  : "bg-[var(--panel)] border-[rgba(200,149,54,0.3)]"
              }`}
            >
              {s.featured && <div className="gold-glow opacity-70" />}
              <div className="relative z-10 flex flex-col h-full">
                <div className="flex items-start justify-between gap-4">
                  <h3 className={`font-serif-display text-3xl md:text-[2.4rem] leading-tight ${s.featured ? "text-[var(--cream)]" : "text-[var(--ink)]"}`}>
                    {s.title}
                  </h3>
                  {s.featured && (
                    <span className="shrink-0 font-sans-ui text-[0.6rem] tracking-[0.2em] uppercase px-3 py-1.5 rounded-full bg-[var(--gold)] text-[var(--noir)]">
                      Signature
                    </span>
                  )}
                </div>

                <div className="flex items-end gap-2 mt-5">
                  <span className={`font-serif-display text-5xl ${s.featured ? "text-[var(--gold-bright)]" : "text-[var(--gold)]"}`}>{s.price}</span>
                </div>
                <p className={`font-sans-ui text-xs tracking-wide mt-1 ${s.featured ? "text-[var(--cream)]/60" : "text-[var(--muted-ink)]"}`}>{s.duration}</p>

                <p className={`font-sans-ui text-sm leading-relaxed font-light mt-6 ${s.featured ? "text-[var(--cream)]/75" : "text-[var(--muted-ink)]"}`}>
                  {s.desc}
                </p>

                <ul className="mt-7 space-y-3 flex-1">
                  {s.features.map((f) => (
                    <li key={f} className={`flex items-start gap-3 font-sans-ui text-sm font-light ${s.featured ? "text-[var(--cream)]/85" : "text-[var(--ink)]"}`}>
                      <Check size={16} className={`mt-0.5 shrink-0 ${s.featured ? "text-[var(--gold-bright)]" : "text-[var(--gold)]"}`} />
                      {f}
                    </li>
                  ))}
                </ul>

                <a
                  href={waLink(`Namaste! I'd like to book the ${s.title} session (${s.price}) with Brahmsara.`)}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`session-book-btn-${i}`}
                  className={`mt-9 text-center font-sans-ui text-sm tracking-wide px-8 py-4 rounded-full transition-colors duration-400 ${
                    s.featured
                      ? "bg-[var(--gold)] text-[var(--noir)] hover:bg-[var(--gold-bright)]"
                      : "bg-[var(--gold)] text-[var(--noir)] hover:bg-[var(--gold)]"
                  }`}
                >
                  Book on WhatsApp
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
